import { handleActions } from 'redux-actions';
import {
  ActionsEnum,
  SetPromoBanners,
  SetTask,
  SetTaskItemState,
  TriggerPostPurchaseSurvey,
} from './home-data.actions';
import { PromoBanner } from './models';
import { List } from 'immutable';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPostPurchaseSurvey, TaskItemStateEnum } from './home-data.data';
import { Task } from './models/task.model';

// feature name
export const FEATURE_NAME = 'home-data';

// state interface
export interface IState {
  promoBanners: List<PromoBanner>;
  postPurchaseSurvey: IPostPurchaseSurvey;
  task: Task;
}

// initial states of store
export const initialState: IState = {
  promoBanners: List([]),
  postPurchaseSurvey: null,
  task: null,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.SET_PROMO_BANNERS]: function (
      state: IState,
      { payload }: SetPromoBanners
    ): IState {
      const { promoBanners } = payload;

      return {
        ...state,
        promoBanners,
      };
    },
    [ActionsEnum.TRIGGER_POST_PURCHASE_SURVEY]: function (
      state: IState,
      { payload }: TriggerPostPurchaseSurvey
    ): IState {
      const { title, header, trackingScreenName } = payload;

      return {
        ...state,
        postPurchaseSurvey: {
          title,
          header,
          trackingScreenName,
        },
      };
    },
    [ActionsEnum.SET_TASK]: function (
      state: IState,
      { payload }: SetTask
    ): IState {
      const { task } = payload;

      return {
        ...state,
        task,
      };
    },
    [ActionsEnum.SET_TASK_ITEM_STATE]: function (
      state: IState,
      { payload }: SetTaskItemState
    ): IState {
      const currentTask = state.task;
      const { id: taskItemId, state: taskItemState } = payload;

      if (taskItemState === TaskItemStateEnum.dismissed) {
        const targetedTaskItemIndex = currentTask.items.findIndex(
          (item) => item.id === taskItemId
        );
        const newTask = currentTask.setIn(
          ['items', targetedTaskItemIndex, 'state'],
          TaskItemStateEnum.dismissed
        ) as Task;

        return {
          ...state,
          task: newTask,
        };
      }

      return state;
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);
export const getPromoBanners = createSelector(
  selectFeature,
  (state: IState) => state.promoBanners
);
export const getPostPurchaseSurvey = createSelector(
  selectFeature,
  (state: IState) => state.postPurchaseSurvey
);
export const getTask = createSelector(
  selectFeature,
  (state: IState) => state.task
);
